<template>
  <el-dialog
    :title="'变更' + roles[model.type]"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opened()"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="变更为：" v-if="model.type == 'dealer'">
        <dealer-select
          :val="model.target_id"
          @change="model.target_id = $event"
        ></dealer-select>
      </el-form-item>

      <el-form-item label="变更为：" prop="target_id" v-else>
        <el-select
          size="small"
          v-model="model.target_id"
          filterable
          placeholder="选择变更目标"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  changeCustomerDealer,
  changeCustomerRelation,
  updateCustomer,
  userList,
} from '../service/getData'
import DealerSelect from '@/components/select/dealer_select'

export default {
  components: { DealerSelect },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible && this.model.type != 'dealer') {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      visible: this.show,
      roles: {
        user: '销售',
        platform_user: '销售',
        industry_sale: '销售',
        science_sale: '销售',
        telesale: '电话销售',
        new_product_sale: '新品销售',
        dealer: '中间商',
      },
      formRules: {
        target_id: [
          { required: true, message: '请选择变更目标', trigger: 'change' },
        ],
      },
      submiting: false,
      users: [],
    }
  },
  methods: {
    async requestUsers() {
      let role_name = this.roles[this.model.type]
      let data = { page: 0, size: 1000, role_name: role_name }
      let res = await userList(data)
      if (res.code == 0) {
        this.users = res.data.list
      }
    },
    opened() {
      if (this.model.type != 'dealer') {
        this.requestUsers()
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          if (this.model.type == 'dealer') {
            let data = {
              customer_id: this.model.customer_id,
              dealer_id: this.model.target_id,
            }
            let res = await changeCustomerDealer(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            console.log(this.model)
            let res = await changeCustomerRelation(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>